// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-card-container {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 12px;
	padding: 10px;
}

@media (max-width: 576px) {
	.header-card-container {
		justify-content: start !important;
		flex-wrap: nowrap !important;
		overflow: scroll !important;
		padding: 10px;
	}
}

.header-card-category {
	min-height: 40px;
}

.header-card-wrapper {
	max-width: calc(23% - 12px);
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
}

@media (max-width: 1000px) {
	.header-card-wrapper {
		flex-grow: 1;
		flex-shrink: 1;
		flex-basis: calc(50% - 12px); /* 2 cards per row on smaller screens */
		max-width: calc(50% - 12px);
	}
}

@media (max-width: 576px) {
	.header-card-wrapper {
		width: 200px;
		flex: 0 1 200px; /* 1 card per row on mobile */
		max-width: 200px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/page-header.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,eAAe;CACf,uBAAuB;CACvB,SAAS;CACT,aAAa;AACd;;AAEA;CACC;EACC,iCAAiC;EACjC,4BAA4B;EAC5B,2BAA2B;EAC3B,aAAa;CACd;AACD;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;CAC3B,sBAAsB;CACtB,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC;EACC,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B,EAAE,uCAAuC;EACnE,2BAA2B;CAC5B;AACD;;AAEA;CACC;EACC,YAAY;EACZ,eAAe,EAAE,6BAA6B;EAC9C,gBAAgB;CACjB;AACD","sourcesContent":[".header-card-container {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tjustify-content: center;\n\tgap: 12px;\n\tpadding: 10px;\n}\n\n@media (max-width: 576px) {\n\t.header-card-container {\n\t\tjustify-content: start !important;\n\t\tflex-wrap: nowrap !important;\n\t\toverflow: scroll !important;\n\t\tpadding: 10px;\n\t}\n}\n\n.header-card-category {\n\tmin-height: 40px;\n}\n\n.header-card-wrapper {\n\tmax-width: calc(23% - 12px);\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n@media (max-width: 1000px) {\n\t.header-card-wrapper {\n\t\tflex: 1 1 calc(50% - 12px); /* 2 cards per row on smaller screens */\n\t\tmax-width: calc(50% - 12px);\n\t}\n}\n\n@media (max-width: 576px) {\n\t.header-card-wrapper {\n\t\twidth: 200px;\n\t\tflex: 0 1 200px; /* 1 card per row on mobile */\n\t\tmax-width: 200px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
